/**
 * downloads.ts
 * [Readme] --------------------------------------------------------------------------------------
 * 
 * 메인 Header에 붙는 다운로드 리스트입니다.
 * 
 * -----------------------------------------------------------------------------------------------
 */

import pdf1 from 'assets/common/221111_provider.pdf';
import pdf2 from 'assets/common/221111_provider02.pdf';
import pdf3 from 'assets/common/221111_notice01_221006.pdf';
import pdf4 from 'assets/common/221111_notice02_221006.pdf';

/**
 * SaleHeader의 상단에 표출되는 다운로드 목록입니다.
 */
export const downloadList = [
  {
    link: pdf1,
    title: '입주자모집공고(전문)'
  },
  {
    link: pdf2,
    title: '입주자모집공고(축약)'
  },
  {
    link: pdf3,
    title: '공급안내문(PDF)'
  },
  {
    link: pdf4,
    title: '청약안내문(PDF)'
  },
];
